import { GET, POST } from './api';
import { SaveObject } from './storage';

export const DoRegister = async (params) => {
  return await POST(`/users`, params);
};

export const DoLogin = async (params) => {
  const response = await POST(`/auth/local`, params);
  // JWT armazenado no httpOnly
  if (response?.user) {
    await SaveObject('user', response.user);
  } else {
    console.warn('Erro: sem dados de user na resposta');
  }

  return response;
};

export const DoLogout = async () => {
  try {
    await GET(`/auth/logout`, true);
  } catch (e) {
    console.log('Erro ao fazer logout no backend:', e);
  }
  // Limpa os dados locais
  await SaveObject('user', null);
  return true;
};

export const DoForgotPassword = async (params) => {
  return await POST(`/auth/forgot-password`, params);
};

export const DoResetPassword = async (params) => {
  return await POST(`/auth/reset-password`, params);
};

export const IsLogged = async () => {
  // verifica se tem cookie de autenticação
  try {
    const user = await ReadMe();
    const isLogged = !!user?.id;
    return isLogged;
  } catch (e) {
    return false;
  }
};

export const ReadMe = async () => {
  return await GET(`/users/me`, true);
};
